import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

/**
 * @deprecated Use global classes from @recruitee/ui/theme/styles/card
 */
@Component({
  selector: 'rt-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
})
export class CardComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'with-border',
      'clickable',
      'inactive',
      'active',
      'background-light',
      'background',
      'no-padding',
    ],
  ];
  @ComponentVariant(CardComponent.VARIANTS)
  @Input()
  public variant: string;
}
